<template>
  <div class="footer">
    <button
      class="projects-btn"
      :style="{marginTop : 'unset', marginBottom: '20px'}"
    ><a href="https://docs.google.com/document/d/13BMZkxZa-x-qUf5ZeQ-GwBZBYcODIwK6Z9xWH2_qDAA/edit" target="_blank">RESUMÉ</a></button>
    <div class="links">
      <ul>
        <li>
          <a href="https://www.linkedin.com/in/yardenroee/" target="_blank">
            <i class="fab fa-linkedin"></i>
            <span></span>
          </a>
        </li>
        <li>
          <a href="https://github.com/yardenroee" target="_blank">
            <i class="fab fa-github"></i>
            <span></span>
          </a>
        </li>
        <li>
          <a href="mailto:yardenroee@gmail.com">
            <i class="fas fa-envelope"></i>
            <span></span>
          </a>
        </li>
      </ul>
    </div>
    <span>SITE MADE BY YARDEN NEGRI</span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>